import { Injectable } from "@angular/core";
import { CommonApiService } from "./common-api.service";
import { APIURL } from "../global/constant";

@Injectable({
  providedIn: "root",
})
export class MasterService {
  constructor(private commonApiService: CommonApiService) {}

  getTargetAudience() {
    return this.commonApiService.get(APIURL.targetAudience);
  }

  getCountryCodeList() {
    return this.commonApiService.get(APIURL.countryList);
  }

  getIndustryList() {
    return this.commonApiService.get(APIURL.industryList);
  }

  getRoleList(payload: any = null) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.roleList, params);
  }

  getroleListtoinvite(payload: any = null) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.roleListtoinvite, params);
  }

  getVideoTypeList() {
    return this.commonApiService.get(APIURL.videoType);
  }

  getToneAndStyle() {
    return this.commonApiService.get(APIURL.toneAndStyle);
  }

  getAIModelList(payload: any) {
    return this.commonApiService.post(APIURL.aiModel, payload);
  }

  getPlatformList() {
    return this.commonApiService.get(APIURL.platforms);
  }

  getScriptTypeList() {
    return this.commonApiService.get(APIURL.scriptType);
  }

  getAudioDeliveryTypeList() {
    return this.commonApiService.get(APIURL.audioDeliveryStyle);
  }

  getVisualStyleList() {
    return this.commonApiService.get(APIURL.visualStyle);
  }

  getSetupsList() {
    return this.commonApiService.get(APIURL.setups);
  }

  getImageStyleList() {
    return this.commonApiService.get(APIURL.imageStyle);
  }

  getConceptManifectMaster() {
    return this.commonApiService.get(APIURL.conceptManifectMaster);
  }

  getScriptOptions() {
    return this.commonApiService.get(APIURL.scriptOptions);
  }

  onAssetApproved(payload: any) {
    return this.commonApiService.post(APIURL.assetApproved, payload);
  }

  getEntityRefType(payload: any) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.entityRefType, params);
  }

  getEntityGenOptions(payload: any) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.entityGenOptions, params);
  }

  fetchParameters(payload: any) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.fetchParameters, params);
  }

  getScheduleCronJobStatus(payload: any) {
    return this.commonApiService.post(APIURL.scheduleCronJobStatus, payload);
  }

  getEditRecipes(payload: {
    stage: string;
    video_id: number | string;
    storyboard_id: number | string;
    shot_id?: number | string;
    variation_id?: number | string;
  }) {
    return this.commonApiService.post(APIURL.editRecipes, payload);
  }

  /** AI Visual (Motion Builder) edit-recipe masters for a shot's clip. */
  getAiVisualEditRecipes(payload: {
    shot_id: number | string;
    video_id: number | string;
    campaign_video_aspect_ratio_id?: number | string;
    variation_id?: number | string;
  }) {
    return this.commonApiService.post(APIURL.editRecipesAiVisual, payload);
  }
  
  getMoodboardEditRecipes(payload: {
    video_id: number | string;
    moodboard_id: number | string;
    entity_version_id: number | string;
    image_id: number | string;
    variation_id?: number | string;
    entity_type: string;
    look_mode: string;
    render_mode: string;
  }) {
    return this.commonApiService.post(APIURL.moodboardEditRecipes, payload);
  }
}
